import { useState } from 'react'
import { Info } from 'lucide-react'

interface MetricTooltipProps {
  metric: 'LCP' | 'FCP' | 'CLS' | 'TTFB' | 'INP'
}

interface MetricInfo {
  fullName: string
  description: string
  good: string
  bad: string
}

const METRICS: Record<MetricTooltipProps['metric'], MetricInfo> = {
  LCP: {
    fullName: 'Largest Contentful Paint',
    description: "Temps de chargement du plus grand element visible.",
    good: '< 2.5s',
    bad: '> 4s',
  },
  FCP: {
    fullName: 'First Contentful Paint',
    description: 'Premier rendu de contenu.',
    good: '< 1.8s',
    bad: '> 3s',
  },
  CLS: {
    fullName: 'Cumulative Layout Shift',
    description: 'Stabilite visuelle.',
    good: '< 0.1',
    bad: '> 0.25',
  },
  TTFB: {
    fullName: 'Time to First Byte',
    description: 'Reponse serveur.',
    good: '< 0.8s',
    bad: '> 1.8s',
  },
  INP: {
    fullName: 'Interaction to Next Paint',
    description: 'Reactivite.',
    good: '< 200ms',
    bad: '> 500ms',
  },
}

export function MetricTooltip({ metric }: MetricTooltipProps) {
  const [visible, setVisible] = useState(false)
  const info = METRICS[metric]

  return (
    <span
      className="relative inline-flex items-center"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      <Info size={14} className="text-[#8B8FA7] cursor-help" />

      {visible && (
        <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 z-50 w-64 max-w-xs bg-white border border-gray-200 shadow-md rounded-lg p-3 text-xs text-left pointer-events-none">
          <p className="font-semibold text-gray-800 mb-1">{info.fullName}</p>
          <p className="text-gray-600 mb-2">{info.description}</p>
          <div className="flex gap-3">
            <span className="text-green-600 font-medium">Bon : {info.good}</span>
            <span className="text-red-500 font-medium">Mauvais : {info.bad}</span>
          </div>
        </div>
      )}
    </span>
  )
}
